import { Box, Card, Typography } from '@mui/material';
import {
  AUDIO_RESOURCES_ICON,
  DOC_ANALYTICS_ICON,
  DOC_RESOURCES_ICON,
  FLASHCARD_ANALYTICS_ICON,
  PDF_RESOURCES_ICON,
  PPT_RESOURCES_ICON,
  XLS_ANALYTICS_ICON,
  XLS_RESOURCES_ICON
} from '../../utils/imageUrls';
import {
  colorPureWhite,
  colorTextBlack,
  colorTextGrey
} from '../../config/theme';
import moment from 'moment';

const resourceIcons = {
  POWERPOINT: PPT_RESOURCES_ICON,
  MSWORD: DOC_ANALYTICS_ICON,
  EXCEL: XLS_ANALYTICS_ICON,
  PDF: PDF_RESOURCES_ICON,
  Flashcard: FLASHCARD_ANALYTICS_ICON,
  Audio: AUDIO_RESOURCES_ICON
};

const formatDate = date => (date ? moment(date).format('MMMM DD, YYYY') : '-');

const ContentCard = ({ contentData, isMedia }) => (
  <Card
    sx={{
      boxShadow: 'none',
      cursor: 'pointer',
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      flex: 1
    }}
  >
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        width: '100%'
      }}
    >
      <div
        style={{
          width: '158px',
          borderRadius: '4px',
          overflow: 'hidden',
          border: !isMedia ? '1px solid #CBD2D9' : 'none',
          position: 'relative'
        }}
      >
        <img
          src={
            isMedia
              ? contentData.uploadType === 'Video'
                ? contentData.thumbnailFileUrl
                : contentData.contentFileUrl
              : resourceIcons[contentData.uploadType]
          }
          alt={contentData.title}
          style={{
            width: '100%',
            height: '100px',
            // objectFit: 'cover',
            display: 'block',
            ...(isMedia ? { borderRadius: '4px' } : {})
          }}
        />
        {contentData.uploadType === 'Video' && (
          <div
            style={{
              position: 'absolute',
              bottom: 10,
              right: 10,
              backgroundColor: colorTextBlack,
              borderRadius: '4px',
              padding: '5px'
            }}
          >
            <Typography
              sx={{ fontSize: '10px', fontWeight: 600, color: colorPureWhite }}
            >
              {contentData.duration || '00:00'}
            </Typography>
          </div>
        )}
      </div>

      <div style={{ flex: '1', padding: '12px', minWidth: 0 }}>
        <Typography
          variant="h6"
          sx={{
            fontWeight: 700,
            fontFamily: 'Lato',
            fontSize: '16px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'wrap', // ✅ Prevents wrapping
            // maxWidth: '350px' // ✅ Prevents unpredictable stretching
            display: 'block', // ✅ Ensures truncation works properly
            lineHeight: '20px'
          }}
        >
          {contentData.title || ''}
        </Typography>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            marginTop: '8px'
          }}
        >
          <Typography
            sx={{
              color: colorTextGrey,
              fontWeight: 500,
              fontFamily: 'Lato',
              fontSize: '14px',
              lineHeight: '18px'
            }}
          >
            {formatDate(contentData.createdDt)}
          </Typography>
        </Box>
      </div>
    </div>
  </Card>
);

const ContentAnalyticsCard = ({ contentData }) => {
  if (!contentData) return null;
  const isMedia = ['Video', 'Image'].includes(contentData.uploadType);
  return <ContentCard contentData={contentData} isMedia={isMedia} />;
};

export default ContentAnalyticsCard;
